export function isNotEmpty(obj) {
  return !!(obj && Object.keys(obj).length);
}

export function isEmpty(obj) {
  return !isNotEmpty(obj);
}

export function jsonp(url, params, callback) {
  // 创建一个唯一的callback函数名，避免与其他请求发生冲突
  const callbackName = `jsonp_${Date.now()}`;
  // 将callback函数名作为查询参数传递给服务端
  params.callback = callbackName;
  // 构造完整的url地址
  const fullUrl = `${url}?${Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join("&")}`;

  // 创建一个script标签，并将其插入到页面中
  const script = document.createElement("script");
  script.src = fullUrl;
  document.body.appendChild(script);

  // 在全局注册回调函数
  window[callbackName] = function (data) {
    // 执行回调函数
    callback(data);
    // 删除script标签
    document.body.removeChild(script);
    // 删除callback函数
    delete window[callbackName];
  };
}

export function isOpenPermissionDialog(userInfo) {
  const state = userInfo.state;
  const hasAuth = userInfo.hasRealNameAuth;

  if (
    (state === 1 && !hasAuth) ||
    (state === 2 && !hasAuth) ||
    (state === 3 && !hasAuth)
  ) {
    // 试营业&&未认证    ||  营业中&&未认证   || 下线&&未认证
    // 完成店铺认证后，即可解锁该模块功能
    return 1;
  } else if (state === 1 && hasAuth) {
    // 试营业、且店铺认证=已认证
    // 试运营考核通过后，即可解锁该模块功能
    return 2;
  } else if (state === 4) {
    // 已关店 不可用
    //您的店铺处于关店状态，该模块功能无法使用
    return 3;
  } else {
    return null;
  }
}
export function isPersonalShop(userInfo) {
  return (
    userInfo.organizationTypeId === 1 ||
    (userInfo.organizationTypeId === 2 && userInfo.shopTypeId === 65)
  );
}
export function objectToQueryString(obj) {
  let params = [];
  Object.keys(obj).forEach(function (key) {
    let encodedKey = encodeURIComponent(key);
    let encodedValue = encodeURIComponent(obj[key]);
    params.push(encodedKey + "=" + encodedValue);
  });

  return params.join("&");
}
// 点击复制
export async function copyContent(content) {
  // 复制结果
  let copyResult = true;
  // 设置想要复制的文本内容
  const text = content || "复制内容为空哦~";
  // 判断是否支持clipboard方式
  if (window.navigator.clipboard) {
    // 利用clipboard将文本写入剪贴板（这是一个异步promise）
    await window.navigator.clipboard
      .writeText(text)
      .then((res) => {
        console.log("clipboard复制成功", res, copyResult);
      })
      .catch((err) => {
        console.log("clipboard复制失败--采取第二种复制方案", err);
        // clipboard方式复制失败 则采用document.execCommand()方式进行尝试
        copyResult = copyContent2(text);
      });
  } else {
    // 不支持clipboard方式 则采用document.execCommand()方式
    copyResult = copyContent2(text);
  }
  // 方法二
  const copyContent2 = (text) => {
    // 复制结果
    let copyResult = true;
    // 创建一个input元素
    let inputDom = document.createElement("textarea");
    // 设置为只读 防止移动端手机上弹出软键盘
    inputDom.setAttribute("readonly", "readonly");
    // 给input元素赋值
    inputDom.value = text;
    // 将创建的input添加到body
    document.body.appendChild(inputDom);
    // 选中input元素的内容
    inputDom.select();
    // 执行浏览器复制命令
    // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签中的内容）
    // Input要在正常的编辑状态下原生复制方法才会生效
    const result = document.execCommand("copy");
    // 判断是否复制成功
    if (result) {
      console.log("execCommand()复制成功");
    } else {
      console.log("execCommand()复制失败");
      copyResult = false;
    }
    // 复制操作后再将构造的标签 移除
    document.body.removeChild(inputDom);
    // 返回复制操作的最终结果
    return copyResult;
  };
  // 返回复制操作的最终结果
  return copyResult;
}
// 下载图片
export async function download(imgUrl, name) {
  // 创建图片Image对象
  let image = new Image();
  // 以CORS的方式去请求这张图片 服务端需要设置CORS进行配合
  image.setAttribute("crossOrigin", "anonymous");
  // 图片加载完成后进行操作
  image.onload = function () {
    // 生成canvas图像
    let canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    let context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    // 得到图片的base64编码数据
    let url = canvas.toDataURL("image/png");
    // 生成一个a元素
    let a = document.createElement("a");
    // 创建一个单击事件
    let event = new MouseEvent("click");
    // 设置download属性 即下载后的文件名称
    a.download = name || "code";
    // 将生成的base64编码数据设置为a.href属性
    a.href = url;
    // 触发a的单击事件 进行下载
    a.dispatchEvent(event);
  };
  // 设置图片地址 开始加载
  image.src = imgUrl;
}
